import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  url = '@cec-api/banner';

  constructor(private http: HttpClient) {}

  getBanners(): Promise<any> {
    return this.http.get(`${this.url}`).toPromise();
  }

  delete(file_name: string): Promise<any> {
    return this.http.delete(`${this.url}/${file_name}`).toPromise();
  }
  changeOrder(order: string[]): Promise<any> {
    return this.http.put(`${this.url}/order`, { order }).toPromise();
  }

  add(form: FormData): Observable<HttpEvent<Object>> {
    return this.http.post('@cec-api/banner', form, {
      reportProgress: true,
      observe: 'events',
      headers: { encrypt: 'multipart/form-data' },
    });
  }
}
